// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"align-vertical"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 12H4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 6L12 9L9 6M15 18L12 15L9 18M12.05 23V16.25M12.05 7.75V1","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const AlignVerticalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'align-vertical',
    ref,
    icon: element,
  },
));

AlignVerticalIcon.displayName = 'AlignVerticalIcon';

export default AlignVerticalIcon;
